import { useMutation, useQueryClient } from "react-query";
import {
  activateSmsCampaigns,
  cancelSmsCampaigns,
  cloneSuggestedCampaign,
  createAudience,
  createSmsCampaigns,
  deleteSmsCampaigns,
  pauseSmsCampaigns,
  updateSmsCampaigns,
} from "../../../services/marketing";

export const useCreateSmsCampaigns = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
    },
  });
};

export const useUpdateSmsCampaigns = (id) => {
  const queryClient = useQueryClient();

  return useMutation((data) => updateSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
      queryClient.invalidateQueries("getSmsCampaignDetails", `${id}`);
    },
  });
};

export const useActivateSmsCampaigns = (id) => {
  const queryClient = useQueryClient();

  return useMutation((data) => activateSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
      queryClient.invalidateQueries("getSmsCampaignDetails", `${id}`);
    },
  });
};

export const useDeleteSmsCampaigns = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
    },
  });
};

export const usePauseSmsCampaigns = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => pauseSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
    },
  });
};

export const useCancelSmsCampaigns = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => cancelSmsCampaigns(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
    },
  });
};

export const useCreateAudience = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createAudience(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getAudiences");
    },
  });
};

export const useCloneSuggestedCampaign = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => cloneSuggestedCampaign(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSmsCampaigns");
    },
  });
};
